module.exports = __webpack_public_path__ + "static/coda_outline-1335b6a30e44cffe1d1df15fad98c731.png";